@let scenario = scenarioSg();
@let canEditScenario = canEditScenarioSg();
@let canDeleteScenario = canDeleteScenarioSg();
@let isCurrentScenario = isCurrentScenarioSg();
@let scenarioUrl =
  scenariosFeature.selectors.getUrlForScenario(scenario).asSignal();
@let isHovering = hoveringSg();
@let showOverflow = showOverflowSg();

<a
  class="atn-scenario-dropdown-overlay-section-scenario"
  [class.atn-scenario-dropdown-overlay-section-scenario--active]="
    isCurrentScenario
  "
  [routerLink]="scenarioUrl"
  (mouseover)="hoveringSg.set(true)"
  (mouseleave)="hoveringSg.set(false)"
  (click)="scenarioClickHandler()"
  #optionOverlayTrigger
>
  <span>{{ scenario.name }}</span>
  @if (isHovering && (canEditScenario || canDeleteScenario)) {
    <span class="atn-scenario-dropdown-overlay-section-scenario__icons">
      @if (canEditScenario) {
        <i
          [class]="[
            'atn-icon atn-edit',
            isCurrentScenario ? 'atn-light' : 'atn-dark',
          ]"
          (click)="$event.stopPropagation(); scenarioUpdateBtnClickedHandler()"
        ></i>
      }
      @if (canEditScenario || canDeleteScenario) {
        <i
          [class]="[
            'atn-icon atn-overflow',
            isCurrentScenario ? 'atn-light' : 'atn-dark',
          ]"
          (click)="$event.stopPropagation(); showOverflowSg.set(true)"
        ></i>
      }
    </span>
  }

  @if (showOverflow) {
    @let otherSections = otherSectionsSg();

    <atn-ds-attached-overlay
      [origin]="optionOverlayTrigger"
      [offsetX]="280"
      [offsetY]="-10"
      backdropClass="ds-global-overlay-backdrop"
      [hasBackdrop]="true"
      (backdropClick)="showOverflowSg.set(false)"
    >
      <div class="atn-scenario-dropdown-overlay-section-scenario__options">
        @for (
          otherSection of canEditScenario ? otherSections : [];
          track $index
        ) {
          <div
            class="atn-scenario-dropdown-overlay-section-scenario__options-item"
            (click)="
              $event.stopPropagation();
              showOverflowSg.set(false);
              onOtherSectionClickHandler(otherSection)
            "
          >
            <div
              class="atn-scenario-dropdown-overlay-section-scenario__options-item-icon"
            >
              <i class="atn-icon atn-blue {{ otherSection.icon }}"></i>
            </div>
            <div
              class="atn-scenario-dropdown-overlay-section-scenario__options-item-name"
            >
              {{ otherSection.name }}
            </div>
          </div>
        }
        @if (canDeleteScenario) {
          <div
            class="atn-scenario-dropdown-overlay-section-scenario__options-item"
            (click)="
              $event.stopPropagation();
              showOverflowSg.set(false);
              scenarioDeleteBtnClickedHandler()
            "
          >
            <div
              class="atn-scenario-dropdown-overlay-section-scenario__options-item-icon"
            >
              <i class="atn-icon atn-trash atn-red"></i>
            </div>
            <div
              class="atn-scenario-dropdown-overlay-section-scenario__options-item-name--red"
            >
              Delete
            </div>
          </div>
        }
      </div>
    </atn-ds-attached-overlay>
  }
</a>
